import React from 'react';
import Rater from 'react-rater';
import { Label } from 'reactstrap';
import { Radio } from 'react-radio-group';
import startCase from 'lodash/startCase';
import capitalize from 'lodash/capitalize';

import SearchTrek from './SearchTrek';
import RangeFilter from './RangeFilter';
import RadioFilter from './RadioFilter';

// const guidedFilterList = ['guided', 'self guided'];
const regionFilterList = ['everest', 'annapurna'];
const dayHikesFilterList = ['day hikes', 'multi day treks'];
// const monthFilterList = [
//   'January',
//   'February',
//   'March',
//   'April',
//   'May',
//   'June',
//   'July',
//   'August',
//   'September',
//   'October',
//   'November',
//   'December',
// ];

export const getStarRatingBody = totalStar =>
  new Array(totalStar).fill(1, 0, totalStar).map((v, i) => {
    const starValue = totalStar - i;
    return (
      <li key={i}>
        <Label>
          <Radio value={starValue} /> <span />
          <Rater total={starValue} rating={starValue} interactive={false} />
        </Label>
      </li>
    );
  });

export const getRadioBody = (valuesList, appendExtra) =>
  valuesList.map(v => (
    <li key={v}>
      <Label>
        <Radio value={v} /> <span />
        {startCase(capitalize(v)) + (appendExtra ? ' ' + capitalize(appendExtra) : '')}
      </Label>
    </li>
  ));

export const trekFilterList = {
  searchTerm: {
    Component: SearchTrek,
    params: data => ({ q: data }),
  },
  price: {
    Component: RangeFilter,
    params: data => ({ starting_price__ge: data.min, starting_price__le: data.max }),
    compProps: {
      dataKey: 'price',
      title: 'Price Range (USD)',
      step: 100,
      defaultValue: { price: { min: 0, max: 3000 } },
    },
  },
  days: {
    Component: RangeFilter,
    params: data => ({ number_of_days__ge: data.min, number_of_days__le: data.max }),
    compProps: {
      dataKey: 'days',
      title: 'Days',
      step: 1,
      defaultValue: { days: { min: 1, max: 30 } },
    },
  },
  // isGuided: {
  //   Component: RadioFilter,
  //   params: data => ({
  //     is_guided: data === 'guided' ? true : false,
  //   }),
  //   compProps: {
  //     title: 'Guided or Self Guided',
  //     body: getRadioBody(guidedFilterList),
  //   },
  // },
  region: {
    Component: RadioFilter,
    params: data => ({ region: data }),
    compProps: {
      title: 'Select Region',
      body: getRadioBody(regionFilterList, 'region'),
    },
  },
  trekType: {
    Component: RadioFilter,
    params: data => {
      const makeQuery =
        data === 'day hikes'
          ? { number_of_days__ge: 1, number_of_days__le: 2 }
          : data === 'multi day treks'
          ? { number_of_days__ge: 2 }
          : { number_of_days__ge: '', number_of_days__le: '' };
      return makeQuery;
    },
    compProps: {
      title: 'Day Hikes or Multi Day',
      body: getRadioBody(dayHikesFilterList),
    },
  },
  // stars: {
  //   Component: RadioFilter,
  //   params: data => ({ q: data }),
  //   compProps: {
  //     title: 'Rating (& up)',
  //     body: getStarRatingBody(4),
  //   },
  // },
  // month: {
  //   Component: RadioFilter,
  //   params: data => ({ q: data }),
  //   compProps: {
  //     title: 'Select Month',
  //     body: getRadioBody(monthFilterList),
  //   },
  // },
};



// WEBPACK FOOTER //
// ./src/screens/TrekListings/TrekFilters/helpers.js